import { Orcamento } from "@/hooks/useOrcamentos";
import { baixarPdfPropostaPreenchida } from './preencherPdfProposta';

export function gerarPdfOrcamento(orcamento: Orcamento) {
  // Usar a nova função de preenchimento de PDF
  return baixarPdfPropostaPreenchida(orcamento);
}